import { render, staticRenderFns } from "./tord_set.vue?vue&type=template&id=5fdcf62c&scoped=true&"
import script from "./tord_set.vue?vue&type=script&lang=js&"
export * from "./tord_set.vue?vue&type=script&lang=js&"
import style0 from "./tord_set.vue?vue&type=style&index=0&id=5fdcf62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdcf62c",
  null
  
)

export default component.exports